import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Main from './pages/main';
import Panel from './pages/panel';

const resources = {
  background: {
    small: '/assets/img/background-small.jpg',
    medium: '/assets/img/background-medium.jpg',
    large: '/assets/img/background-large.jpg',
    xlarge: '/assets/img/background-xlarge.jpg',
  },
  pattern: '/assets/img/glow.png',
};

export const Routes: React.FC = () => {
  return (
    <Switch>
      <Route path="/" exact>
        <Main resources={resources} />
      </Route>
      <Route path="/panel">
        <Panel resources={resources} />
      </Route>
    </Switch>
  );
};
